(()=>{
  'use strict';
  const formId='R2Zj88';
  const labels=document.currentScript.dataset;
  const attach=()=>document.querySelectorAll('.lumi-golden-card').forEach(card=>{
    if(card.dataset.scratchReady==='true')return;
    card.dataset.scratchReady='true';
    const canvas=document.createElement('canvas');
    canvas.setAttribute('aria-label',labels.canvasLabel);
    Object.assign(canvas.style,{position:'absolute',inset:'0',width:'100%',height:'100%',touchAction:'none',borderRadius:'3px',zIndex:'2'});
    const context=canvas.getContext('2d',{willReadFrequently:true});
    if(!context)return;
    const fallback=document.createElement('button');
    fallback.type='button';fallback.textContent=labels.revealButton;
    Object.assign(fallback.style,{display:'block',margin:'8px auto',padding:'12px',minHeight:'44px',font:'12px Arial,sans-serif',color:'#143e3e',textDecoration:'underline',border:'0',background:'transparent'});
    let opened=false,pressed=false,last=null,lastCheck=0;
    const draw=()=>{
      if(opened)return;
      const w=card.clientWidth,h=card.clientHeight,d=Math.min(window.devicePixelRatio||1,2);
      if(w<1||h<1)return;
      canvas.width=w*d;canvas.height=h*d;context.setTransform(d,0,0,d,0,0);
      context.globalCompositeOperation='source-over';
      const g=context.createLinearGradient(0,0,w,h);
      [[0,'#8b6422'],[.2,'#d4ae59'],[.42,'#f3dea3'],[.58,'#b98c38'],[.8,'#e8c879'],[1,'#967126']].forEach(([p,c])=>g.addColorStop(p,c));
      context.fillStyle=g;context.fillRect(0,0,w,h);context.strokeStyle='#fff0ba55';context.lineWidth=.6;
      for(let i=-h;i<w+h;i+=7){context.beginPath();context.moveTo(i,0);context.lineTo(i+h,h);context.stroke();}
      context.strokeStyle='#71521f';context.lineWidth=1;context.strokeRect(12,12,w-24,h-24);
      context.textAlign='center';context.fillStyle='#423016';context.font='12px Arial';context.fillText('L U M I L A S H',w/2,h*.27);
      context.font='31px Georgia';context.fillText('Golden Ticket',w/2,h*.52);
      context.font='11px Arial';context.fillText(labels.scratchHint,w/2,h*.74);
    };
    const observer=new ResizeObserver(draw);
    const reveal=()=>{
      if(opened)return;opened=true;canvas.remove();observer.disconnect();fallback.textContent=labels.revealed;fallback.disabled=true;fallback.style.textDecoration='none';
      card.setAttribute('role','status');card.setAttribute('aria-live','polite');
    };
    const point=e=>{const rect=canvas.getBoundingClientRect();return{x:e.clientX-rect.left,y:e.clientY-rect.top};};
    const scratch=p=>{
      if(opened)return;
      context.globalCompositeOperation='destination-out';context.lineWidth=40;context.lineCap='round';context.beginPath();context.moveTo(last?last.x:p.x,last?last.y:p.y);context.lineTo(p.x+.1,p.y);context.stroke();last=p;
      if(performance.now()-lastCheck<120)return;lastCheck=performance.now();
      const pixels=context.getImageData(0,0,canvas.width,canvas.height).data;let n=0,clear=0;
      for(let i=3;i<pixels.length;i+=64){n++;if(pixels[i]<30)clear++;}
      if(n&&clear/n>.38)reveal();
    };
    canvas.addEventListener('pointerdown',e=>{pressed=true;last=null;canvas.setPointerCapture(e.pointerId);scratch(point(e));});
    canvas.addEventListener('pointermove',e=>{if(pressed)scratch(point(e));});
    ['pointerup','pointercancel','lostpointercapture'].forEach(type=>canvas.addEventListener(type,()=>{pressed=false;last=null;}));
    fallback.addEventListener('click',reveal);
    card.append(canvas);card.after(fallback);observer.observe(card);draw();
  });
  window.addEventListener('klaviyoForms',event=>{
    if(event.detail?.formId!==formId)return;
    if(['open','stepSubmit'].includes(event.detail.type))requestAnimationFrame(attach);
  });
  let scheduled=false;
  const observer=new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;attach();});});
  observer.observe(document.body,{childList:true,subtree:true});attach();
})();
